import React from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../services/utilityFunctions';
import translate from '../../../commonComponents/translate';
import withCSRF from '../../../commonComponents/withCSRF';
import Modal from '../../../commonComponents/modal/Modal';

/**
 * User profile main page
 */
function CongratsModal({ t, trophy, onClose, onContinue, continueText }) {
  return (
    <Modal onClose={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-journey"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <div className="image-modal">
              <img src={trophy.imageURL} alt="trophy" />
            </div>
            {onClose && (
              <button type="button" className="close" onClick={onClose}>
                <span aria-hidden="true">×</span>
              </button>
            )}
          </div>
          <div className="modal-body">
            <div className="container-fluid">
              <h3 className="congratulations">
                {t('journey_congratulations')}
              </h3>
              <p>
                {t('journey_trophyWon1')}
                <span className="text-dynamic">{trophy.name}</span>
                {t('journey_trophyWon2')}
              </p>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-dynamic"
              onClick={onContinue}
            >
              {t(continueText)}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

CongratsModal.propTypes = {
  t: PropTypes.func.isRequired,
  trophy: PropTypes.shape({
    name: PropTypes.string,
    imageURL: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  continueText: PropTypes.string,
};

CongratsModal.defaultProps = {
  continueText: 'journey_continue',
};

export default compose(
  withCSRF,
  translate,
)(CongratsModal);
